import React from 'react';

import { Locales } from 'src/lib/constants';
import { TopicPageTemplate } from 'src/templates';
import {
  getResourcesTopicStaticPaths,
  getResourcesTopicStaticProps,
} from 'src/lib/resources-page-data';

const TopicPage = ({ articles, topics, totalArticles, ...props }) => {
  return (
    <TopicPageTemplate
      articles={articles}
      topics={topics}
      totalArticles={totalArticles}
      locale={Locales.EN_US}
      {...props}
    />
  );
};

export async function getStaticPaths() {
  return getResourcesTopicStaticPaths({ locale: Locales.EN_US });
}

export async function getStaticProps({ params, preview }) {
  return getResourcesTopicStaticProps({
    locale: Locales.EN_US,
    preview,
    params,
  });
}

export default TopicPage;
